
export interface IApiResponseInvoice {
    id: number,
    date: string,
    booking_id: number,
    booking_number: string,
    service_type: string,
    payment_due: string,
    status: string,
    is_paid: boolean,
    is_payable: boolean,
    amount: number,
    currency: string,
    tax_percent: number,
    tax_charge_rs: number,
    tax_total: number,
    invoice_url: string,
    invoice_file_name: string,
}

export enum INVOICE_STATUSES {
    PAID = 'paid',
    WAITING_PAYMENT = 'waiting_payment',
    EXPIRED = 'expired',
}